module.exports = __webpack_public_path__ + "media/images/version_merge/no_attempts_client-340ce9d8ba49dbcb58de626580dae7c5.png";